import { render, staticRenderFns } from "./returnInfo.vue?vue&type=template&id=0ebbbe12&scoped=true"
import script from "./returnInfo.vue?vue&type=script&lang=js"
export * from "./returnInfo.vue?vue&type=script&lang=js"
import style0 from "./returnInfo.vue?vue&type=style&index=0&id=0ebbbe12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebbbe12",
  null
  
)

export default component.exports